class Submenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {}

  init() {
    setTimeout(() => {
      this.style.display = 'block';
    }, 300);
    window.addEventListener('scroll', () => {
      this.removeAttribute('open');
    });
  }
}

if (!customElements.get('mca-submenu')) {
  customElements.define('mca-submenu', Submenu);
}
